export default [
  {
    path: '/blog',
    name: 'blog',
    component: () => import('@/views/menu/blog/blog.vue'),
    meta: {
      pageTitle: 'مدیریت مقاله ها',
      action: 'show',
      resource: 'BlogManager',
    },
  },
  {
    path: '/blog/details',
    name: 'addblog',
    component: () => import('@/views/menu/blog/blogdetails.vue'),
    meta: {
      pageTitle: 'ایجاد مقاله',
      action: 'show',
      resource: 'BlogManager',
    },
  },
  {
    path: '/blog/details/:id',
    name: 'updateblog',
    component: () => import('@/views/menu/blog/blogdetails.vue'),
    meta: {
      pageTitle: 'ویرایش مقاله',
      action: 'show',
      resource: 'BlogManager',
    },
  },
  {
    path: '/blogcategory',
    name: 'blogcategory',
    component: () => import('@/views/menu/blog/blogcategory.vue'),
    meta: {
      pageTitle: 'مدیریت دسته بندی های مقاله',
      action: 'show',
      resource: 'BlogCategoryManager',
    },
  },
  {
    path: '/blogcategory/details',
    name: 'addblogcategory',
    component: () => import('@/views/menu/blog/blogcategorydetails.vue'),
    meta: {
      pageTitle: 'ایجاد دسته بندی مقاله',
      action: 'show',
      resource: 'BlogCategoryManager',
    },
  },
  {
    path: '/blogcategory/details/:id',
    name: 'updateblogcategory',
    component: () => import('@/views/menu/blog/blogcategorydetails.vue'),
    meta: {
      pageTitle: 'ویرایش دسته بندی مقاله',
      action: 'show',
      resource: 'BlogCategoryManager',
    },
  },
  {
    path: '/blogcomment',
    name: 'blogcomment',
    component: () => import('@/views/menu/blog/blogcomment.vue'),
    meta: {
      pageTitle: 'مدیریت نظرها',
      action: 'show',
      resource: 'BlogCommentManager',
    },
  },
  {
    path: '/blogRedirect',
    name: 'blogRedirect',
    component: () => import('@/views/menu/blog/blogRedirect.vue'),
    meta: {
      pageTitle: 'مدیریت لینک ها',
      action: 'show',
      resource: 'BlogManager',
    },
  },
]
